import React from 'react';

import classNames from 'classnames';

import {InnerHtml} from 'components/innerHtml/innerHtml';

import {BadgePositionType} from '../../../types';

import s from './bannerBadge.scss';

type PropsType = {
    position: BadgePositionType;
    icon: string;
    height: number;
    link: string;
};

const POSITIONS_MAP: Record<BadgePositionType, string> = {
    'bottom-left': s.bottomLeft,
    'bottom-right': s.bottomRight,
    'top-left': s.topLeft,
    'top-right': s.topRight,
} as const;

/**
 * SVG Badge inside imageBanner with configurations from CMS
 */
export const BannerBadge = ({height, icon, link, position}: PropsType) => {
    const positionClassName = POSITIONS_MAP?.[position];

    if (!positionClassName) return null;

    return (
        <InnerHtml
            className={classNames(s.badge, positionClassName)}
            href={link}
            html={icon}
            style={{height}}
            tag="a"
        />
    );
};
